import { axiosInstance } from '@/providers/axiosInstance';
import type { AdminTokenResponse } from '@/types';

const CLIENT_FLUFFY_BASE =
  import.meta.env.VITE_CLIENT_FLUFFY_URL ?? 'http://localhost:3000';

async function fetchAdminToken(): Promise<string> {
  const response =
    await axiosInstance.post<AdminTokenResponse>('/api/admin/token');
  return response.data.token;
}

/**
 * Opens a client-fluffy page (preview, confirmation, generating) in a new tab,
 * authenticated with a freshly-minted admin token.
 *
 * The blank tab is opened synchronously inside the click handler so the popup
 * blocker permits it, then navigated once the token resolves. We must NOT pass
 * `noopener`/`noreferrer` to `window.open` here: per the HTML spec those
 * features make it return `null`, which would strand the tab on about:blank
 * forever (the navigation in `.then` is guarded by `if (win)`). Instead we keep
 * the handle and sever the opener link manually after navigating.
 */
export function openWithAdminToken(path: string): void {
  const win = window.open('about:blank', '_blank');
  fetchAdminToken()
    .then((token) => {
      if (!win) return;
      win.opener = null;
      win.location.href = `${CLIENT_FLUFFY_BASE}${path}?admin_token=${encodeURIComponent(token)}`;
    })
    .catch(() => {
      if (win) win.close();
    });
}
